import { isFaqs } from '@/utils/isFaqs';
import Accordion, { type ListItem } from '@/components/Accordion';
import HelpMenu from '@/components/HelpMenu';
import {
  HelpPageContainer,
  AccordionContainer,
  Container,
  Description,
  SmallTitle,
  Title,
  OrderedListItem,
  OrderedListItemContainer,
} from './styledComponents';
import { setCurrentPage } from '@/utils/setCurrentPage';
import { useRouter } from 'next/router';

type HelpPageLayoutProps = {
  title: string;
  description: string;
  linkText?: string;
  linkUrl?: string;
  list: ListItem[];
  linkInListText?: string;
  linkInListUrl?: string;
  contactUsText?: string;
  cookies?: string[];
};

const HelpPageLayout = ({
  list,
  description,
  linkText,
  linkUrl,
  title,
  linkInListText,
  linkInListUrl,
  contactUsText,
  cookies,
}: HelpPageLayoutProps) => {
  const router = useRouter();

  const currentPage = setCurrentPage(router.pathname);
  const isHelpMenu =
    setCurrentPage(router.pathname) === 'faqs' ||
    setCurrentPage(router.pathname) === 'contact-us';

  const hasAccordion =
    setCurrentPage(router.pathname) !== 'terms-and-conditions';

  const hasLink = linkText !== 'linkText' && linkUrl !== 'linkUrl';

  const splitDescription = description.split(/(terms-and-conditions-link)/);
  const beforeLink = splitDescription[0];
  const afterLink = splitDescription[2];

  return (
    <Container>
      {isHelpMenu ? (
        <HelpMenu currentPage={currentPage} />
      ) : (
        <HelpPageContainer>
          {currentPage === 'contact-us' ||
            (currentPage === 'faqs' && <HelpPageTitle title={title} />)}
          <Description>
            {hasLink ? (
              <>
                {beforeLink}
                <a href={linkUrl} target="_blank" rel="noopener noreferrer">
                  {linkText}
                </a>
                {afterLink}
              </>
            ) : (
              <>{description}</>
            )}
          </Description>
        </HelpPageContainer>
      )}
      {hasAccordion ? (
        <AccordionContainer>
          <Accordion
            list={list}
            linkInListText={linkInListText}
            linkInListUrl={linkInListUrl}
            contactUsText={contactUsText}
            cookies={cookies}
          />
        </AccordionContainer>
      ) : (
        <OrderedListItemContainer>
          {list.map(item => (
            <OrderedListItem key={`t&c-${item.title}-${item.description}`}>
              {item.description}
            </OrderedListItem>
          ))}
        </OrderedListItemContainer>
      )}
    </Container>
  );
};

type HelpPageTitleProps = { title: string };

const HelpPageTitle = ({ title }: HelpPageTitleProps) => {
  return (
    <>
      <Title $isFaqs={isFaqs(title)}>{title}</Title>
      <SmallTitle $isFaqs={isFaqs(title)}>FAQs</SmallTitle>
    </>
  );
};

export default HelpPageLayout;
